"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _entrySourceStatsTable = _interopRequireDefault(require("./entry-source-stats-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ByCompetition extends _react.Component {
  render() {
    const statsByCompetition = this.props.statsByYear.entrySource.filter(es => es.rdbRaceIDs) // only those races that are mapped
    .reduce((comps, row) => {
      if (comps && comps[row.competitionID]) {
        comps[row.competitionID].totalCompeted += row.totalCompeted;
        comps[row.competitionID].competedAndEnteredOnline += row.competedAndEnteredOnline;
        comps[row.competitionID].competedAndPreEnteredByPost += row.competedAndPreEnteredByPost;
        comps[row.competitionID].enteredOnDay += row.totalCompeted - row.competedAndEnteredOnline - row.competedAndPreEnteredByPost;
        comps[row.competitionID].totalEntered += row.totalEntered;
        comps[row.competitionID].enteredOnlineAndNotInResults += row.enteredOnlineAndNotInResults;
        comps[row.competitionID].enteredByPostAndNotInResults += row.enteredByPostAndNotInResults;
        comps[row.competitionID].preEntered += row.totalEntered - row.enteredOnlineAndNotInResults - row.enteredByPostAndNotInResults;
      } else {
        comps[row.competitionID] = {
          statsID: row.competitionID,
          statsDescription: row.competitionName,
          startDate: row.competitionStartDate,
          totalCompeted: row.totalCompeted,
          competedAndEnteredOnline: row.competedAndEnteredOnline,
          competedAndPreEnteredByPost: row.competedAndPreEnteredByPost,
          enteredOnDay: row.totalCompeted - row.competedAndEnteredOnline - row.competedAndPreEnteredByPost,
          totalEntered: row.totalEntered,
          enteredOnlineAndNotInResults: row.enteredOnlineAndNotInResults,
          enteredByPostAndNotInResults: row.enteredByPostAndNotInResults,
          preEntered: row.totalEntered - row.enteredOnlineAndNotInResults - row.enteredByPostAndNotInResults
        };
      }
      return comps;
    }, []).sort((a, b) => {
      if (a.startDate > b.startDate || a.startDate === b.startDate && a.statsDescription.toUpperCase() > b.statsDescription.toUpperCase()) return 1;
      return -1;
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card",
      style: {
        marginTop: 15
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("h3", null, " Entry Source Analysis By Competition for ", this.props.statsByYear.id)), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_entrySourceStatsTable.default, {
      stats: statsByCompetition
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ByCompetition;